<template>
  <SwiperJs ref="swiper"
    class="accounts-signup-operation"
    :swipeable="false"
    :allowSlideNext="false"
    :allowSlidePrev="false">


<!-- check_browser -->
    <AccountsStepOperationStep :hidden="activeStep !== 'check_browser'">

        <AccountsCard
          loading
          :error="getStepError('check_browser')"
          :description="gettext('Checking browser..')"
        />
      
    </AccountsStepOperationStep>


<!-- fetch_backend_stats -->
    <AccountsStepOperationStep :hidden="activeStep !== 'fetch_backend_stats'"
        :show-next-button="getStepError('fetch_backend_stats') != null"
        @nextButtonPressed="restartOperation"
        :next-button-text="gettext('Reload')"
        remote-step>

        <AccountsCard
          :loading="getStepError('fetch_backend_stats') == null"
          :error="getStepError('fetch_backend_stats')"
          :description="gettext('Fetching backend stats..')"
        />

    </AccountsStepOperationStep>


<!-- check_availability -->
    <AccountsStepOperationStep :hidden="activeStep !== 'check_availability'"
        :show-next-button="getStepError('check_availability') != null"
        @nextButtonPressed="restartOperation"
        :next-button-text="gettext('Reload')"
        remote-step>

        <AccountsCard
          :hide-media="signupClosed"
          :description="signupClosed ? null : gettext('Checking availability..')"
          >
          <h2 v-if="signupClosed">
            {{ gettext('We are sorry, but the sign up is currently closed.') }}
          </h2>
        </AccountsCard>

    </AccountsStepOperationStep>


<!-- instructions  -->
    <AccountsStepOperationStep :hidden="activeStep !== 'instructions'"
        first-step
        @nextButtonPressed="startOperation">

        <AccountsCard
          hide-media >

            <div class="instructions">
                <h2>{{gettext('Instructions')}}</h2>

                <!-- <h3>1. {{gettext('Choose user type')}}</h3> -->
                <h3>1. {{gettext('Select your Country')}}</h3>
                <h3>2. {{gettext('Choose user type')}}</h3>
                <h3>3. {{gettext('Insert e-mail')}}</h3>
                <h3>4. {{gettext('Insert password (if required)')}}</h3>
                <h3>5. {{gettext('Check your e-mail box')}}</h3>

            </div>

        </AccountsCard>

    </AccountsStepOperationStep>


<!-- select-country -->
    <AccountsStepOperationStep :hidden="activeStep !== 'select-country'"
        :backButtonText="gettext('help')"
        @backButtonPressed="activateStep('instructions')"
        @nextButtonPressed="countrySelected">

        <AccountsCard
          hide-media
          :error="firstStepError"
          :description="gettext('Select your Country')"
        >

          <div class="countrySelectorContainer">
            <country-select v-model="countryCode"
                            :country="countryCode"
                            placeholder="---"
                            className="countryCodeSelector"/>
          </div>

        </AccountsCard>

    </AccountsStepOperationStep>


<!-- choose-user-type -->
    <AccountsStepOperationStep :hidden="activeStep !== 'choose-user-type'"
        hide-next-button
        @backButtonPressed="activateStep('select-country')">

        <AccountsCard
          hide-media
          :error="firstStepError"
          :description="gettext('Choose one of the following user types')"
        >

          <AccountsGroupsList
            :groups="groupsList()"
            @groupSelected="groupSelected"
            />

        </AccountsCard>

    </AccountsStepOperationStep>


<!-- show-user-type-info -->
    <AccountsStepOperationStep :hidden="activeStep !== 'show-user-type-info'"
        @backButtonPressed="activateStep('choose-user-type')"
        @nextButtonPressed="stepCompleted('show-user-type-info', true)">

        <AccountsCard
          hide-media
        >
          <div class="informations scrollable" v-html="userTypeInfo"></div>

        </AccountsCard>

    </AccountsStepOperationStep>


<!-- check_user_type  -->
    <AccountsStepOperationStep :hidden="activeStep !== 'check_user_type'"
        remote-step>

        <AccountsCard
          loading
          :error="getStepError('check_user_type')"
          :description="gettext('Checking..')"
        />

    </AccountsStepOperationStep>


<!-- insert-email -->
    <AccountsStepOperationStep :hidden="activeStep !== 'insert-email'"
       @backButtonPressed="activateStep('choose-user-type')"
       @nextButtonPressed="stepCompleted('insert-email', userEmail)"
     >

        <AccountsCard
          :description="gettext('Insert e-mail, will be used for later communications')"
          :error="getStepError('check_email')"
          @nextButtonPressed="stepCompleted('insert-email', userEmail)"
        >

          <AccountsMdcTextField
            name="email"
            type="text"
            placeholder="E-mail"
            ref="userEmailInput"
            v-model="userEmail"
            :tabindex="activeStep === 'insert-email' ? 0 : -1"
            @submitted="stepCompleted('insert-email', userEmail)"
          />

        </AccountsCard>

    </AccountsStepOperationStep>


<!-- check_email -->
    <AccountsStepOperationStep :hidden="activeStep !== 'check_email'"
        remote-step
     >

        <AccountsCard
          loading
          :description="gettext('Checking..')"
        >
        </AccountsCard>

    </AccountsStepOperationStep>


<!-- insert-password -->
    <AccountsStepOperationStep :hidden="activeStep !== 'insert-password'"
        @nextButtonPressed="stepCompleted('insert-password', userPassword)"
        @backButtonPressed="goToStep('insert-email')">

        <AccountsCard
          :description="gettext('Choose a strong password')"
          :error="getStepError('check_password') || getStepError('check_confirmed_password')"
          hide-media
          >

          <AccountsMdcTextField
            name="password"
            type="password"
            placeholder="Password"
            ref="userPasswordInput"
            v-model="userPassword"
            :tabindex="activeStep === 'insert-password' ? 0 : -1"
            @submitted="stepCompleted('insert-password', userPassword)"
          />

        </AccountsCard>
    </AccountsStepOperationStep>


<!-- check_password -->
    <AccountsStepOperationStep :hidden="activeStep !== 'check_password'"
        remote-step
     >

        <AccountsCard
          loading
          :description="gettext('Checking..')"
        >
        </AccountsCard>

    </AccountsStepOperationStep>


<!-- confirm-password -->
    <AccountsStepOperationStep :hidden="activeStep !== 'confirm-password'"
        @nextButtonPressed="stepCompleted('confirm-password', userPassword2)"
        @backButtonPressed="goToStep('insert-password')">

        <AccountsCard
          :description="gettext('Confirm password')"
          hide-media >

          <AccountsMdcTextField
            name="password"
            type="password"
            placeholder="Password"
            ref="userPasswordInput2"
            v-model="userPassword2"
            :tabindex="activeStep === 'confirm-password' ? 0 : -1"
            @submitted="stepCompleted('confirm-password', userPassword2)"
          />

        </AccountsCard>
    </AccountsStepOperationStep>


<!-- check_confirmed_password -->
    <AccountsStepOperationStep :hidden="activeStep !== 'check_confirmed_password'"
        remote-step
     >

        <AccountsCard
          loading
          :description="gettext('Checking..')"
        >
        </AccountsCard>

    </AccountsStepOperationStep>


<!-- check-informations -->
    <AccountsStepOperationStep :hidden="activeStep !== 'check-informations'"
        @backButtonPressed="goToStep('insert-email')"
        @nextButtonPressed="stepCompleted('check-informations', true)"
     >

        <AccountsCard
          hide-media
        >
            <div class="check-informations">
                <h2>{{ gettext('Check informations') }}</h2>
                <h3>e-mail: {{userEmail}}</h3>
                <!-- <h3>{{gettext('User type')}}: {{choosenUserType}}</h3> -->
            </div>

        </AccountsCard>

    </AccountsStepOperationStep>


<!-- run_tasks -->
    <AccountsStepOperationStep :hidden="activeStep !== 'run_tasks'"
        remote-step>

        <AccountsCard
          loading
          :description="gettext('Signin up..')"
          :error="getStepError('run_tasks')"
        >
        </AccountsCard>

    </AccountsStepOperationStep>


<!-- send_events -->
    <AccountsStepOperationStep :hidden="activeStep !== 'send_events'"
        remote-step>

        <AccountsCard
          loading
          :description="gettext('Sending events..')"
        >
        </AccountsCard>
    </AccountsStepOperationStep>


<!--  result -->
    <AccountsStepOperationStep :hidden="activeStep !== 'result'"
        remote-step>

        <AccountsCard
          loading
          :description="gettext('Confirmation e-mail sent. Please check your inbox.')"
        >
        </AccountsCard>
      
    </AccountsStepOperationStep>


  </SwiperJs>
</template>

<script>
import Modernizr from 'modernizr'

import moment from 'moment-timezone'

import GettextMixin from '@paiuolo/pai-vue-gettext/mixins/GettextMixin'
import LoadingElementMixin from '@paiuolo/pai-vue-mixins/mixins/LoadingElementMixin'
import FieldValidatorsMixin from '@paiuolo/pai-vue-mixins/mixins/FieldValidatorsMixin'

import FetchBackendStatsMixin from '@paiuolo/django-sso-app-vue-mixins/mixins/FetchBackendStatsMixin'
import ApiSignupMixin from '@paiuolo/django-sso-app-vue-mixins/mixins/ApiSignupMixin'
import CheckUserExistenceMixin from '@paiuolo/django-sso-app-vue-mixins/mixins/CheckUserExistenceMixin'
import UserProfileMixin from '@paiuolo/django-sso-app-vue-mixins/mixins/UserProfileMixin'
import BrowserFingerprintMixin from '@paiuolo/django-sso-app-vue-mixins/mixins/BrowserFingerprintMixin'

import SwiperJs from '@paiuolo/pai-vue-swiper/elements/swiper/SwiperJs'
import StepOperationSwiperJsMixin from '@paiuolo/pai-vue-swiper/mixins/StepOperationSwiperJsMixin'

import AccountsStepOperationStep from 'q-custom-elements/src/components/elements/layout/step-operations/accounts/AccountsStepOperationStep'
import AccountsMdcTextField from 'q-custom-elements/src/components/elements/input/accounts/AccountsMdcTextField'

import AccountsCard from 'q-custom-elements/src/components/elements/layout/step-operations/accounts/AccountsCard'

import AccountsGroupsList from 'q-custom-elements/src/components/entities/group/accounts/AccountsGroupsList'

import STEP_OPERATION from '@/step-operations/accounts-signup.json'

export default {
  name: 'AccountsSignupOperation',

  mixins: [
    GettextMixin,
    LoadingElementMixin,
    FieldValidatorsMixin,
    ApiSignupMixin,
    StepOperationSwiperJsMixin,
    CheckUserExistenceMixin,
    UserProfileMixin,
    FetchBackendStatsMixin,
    BrowserFingerprintMixin
  ],

  components: {
    SwiperJs,
    AccountsStepOperationStep,
    AccountsCard,
    AccountsMdcTextField,
    AccountsGroupsList
  },

  props: {
    loaded: {
      type: Boolean,
      default: true
    },
    fetchBackendStatsUrl: {
      type: String,
      default: process.env.VUE_APP_DJANGO_SSO_APP_URL + '/api/v1/_stats/'
    },
    checkUserExistenceUrl: {
      type: String,
      default: process.env.VUE_APP_DJANGO_SSO_APP_URL + '/api/v1/auth/check-user/'
    },
	apiSignupUrl: {
      type: String,
      default: process.env.VUE_APP_DJANGO_SSO_APP_URL + '/api/v1/auth/signup/'
    }
  },

  data () {
    return {
      operationStarted: false,
      operationCompleted: false,
      operationError: null,
      operationLink: document.href,

      countryCode: 'IT',

      stepOperation: STEP_OPERATION
    }
  },

  computed: {
    signupClosed () {
      return document.APP && document.APP.signupClosed
    },
    firstStepError () {
      return this.getStepError('run_tasks') || null
    },
    passwordError () {
      return this.getStepError('check_password') || this.getStepError('check_confirmed_password') || null
    },
    canCancelOperation () {
      return [].indexOf(this.activeStep) > -1
    },
    backendStats: {
      get () {
        return this.getStepResult('fetch_backend_stats')
      }
    },
    selectedCountry: {
      get () {
        let selectedCountry = this.getStepResult('select-country')

        if (selectedCountry) {
          return selectedCountry.code
        } else {
          return null
        }
      }
    },
    choosenUserType: {
      get () {
        let choosenGroup = this.getStepResult('choose-user-type')

        if (choosenGroup) {
          return choosenGroup.name
        } else {
          return null
        }
      }
    },
    userEmail: {
      get () {
        return this.getStepResult('insert-email')
      },
      set (val) {
        this.setStepResult('insert-email', val)
      }
    },
    userPassword: {
      get () {
        return this.getStepResult('insert-password')
      },
      set (val) {
        this.setStepResult('insert-password', val)
      }
    },
    userPassword2: {
      get () {
        return this.getStepResult('confirm-password')
      },
      set (val) {
        this.setStepResult('confirm-password', val)
      }
    },
    userTypeInfo: {
      get () {
        let uTI = this.getStepResult('choose-user-type')
        return (uTI && uTI.description) || ''
      }
    }
  },

  mounted () {
    this.countryCode = this.getCountryCodeFromTimezone()
  },

  methods: {
    getAllCountryCodes() {
      const allTimezones = moment.tz.names(); // Get all time zone names
      const countryCodesSet = new Set();

      // Extract countries associated with each time zone
      allTimezones.forEach((timezone) => {
          const countries = moment.tz.zone(timezone)?.countries();
          if (countries) {
              countries.forEach((code) => countryCodesSet.add(code));
          }
      });

      return Array.from(countryCodesSet).sort(); // Convert Set to sorted array
    },
    getCountryCodeFromTimezone() {
      try {
        // Get the browser's timezone
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // Use moment-timezone to get the country code
        const countries = moment.tz.zone(timezone)?.countries() || [];
        //console.log('cc', timezone, countries)

        // Return the first country code if found
        if (countries.length > 0) {
          return countries[0]; // ISO 3166-1 alpha-2 country code
        } else {
          return "IT";
        }
      } catch (error) {
        console.error("Error detecting country code:", error);
        return "IT";
      }
    },
    clear () {
      this.operationCompleted = false
      this.clearStepOperation()

      this.activateStep('check_browser')
    },
    startOperation () {
      this.operationStarted = true
      this.activateStep('select-country')
    },
    cancelOperation () {
      this.clear()
      this.$emit('operationCancelled')
    },
    completeOperation () {
      this.operationLink = document.location.href

      this.operationCompleted = true
      this.$emit('operationCompleted')
    },
    stopOperation () {
      this.activateStep('select-country')
      this.$emit('operationStopped')
    },
    restartOperation () {
      this.clear()
      this.$emit('operationRestarted')
    },

    // step related

    checkBrowser () {
      if (Modernizr.blobconstructor && Modernizr.svg && Modernizr.promises && Modernizr.filereader) {
        this.stepCompleted('check_browser', true, 'fetch_backend_stats')
      } else {
        this.stepFailed('check_browser', this.gettext('This browser is not supported.'))
      }
    },

    countrySelected() {
      this.stepCompleted('select-country', this.countryCode)
    },
    groupSelected(group) {
      this.stepCompleted('choose-user-type', group)
    },

    goToLogin () {
        window.location.href = '/login/'
    },

    groupsList () {
      /*
        Citizen (Cittadino)
        Enterprise (Impresa)
        Public Entity (Ente Pubblico)
        Consultant (Consulente)
          Proponente Dgr. 5223/21 della Regione Lombardia
          Proponente Dgr. 117/23 della Regione Umbria
          Other (Altro)
        Educational Institution (Ente Educativo)
      * */
      if (this.backendStats) {
        return this.backendStats.user_types.map(el => {
            if (['citizen'].indexOf(el.name) > -1)  {
              el['alias'] = this.gettext('Citizen')
              el['picture'] = process.env.VUE_APP_CDN_URL + '/static/img/logos/q-people.svg'
              el['description'] = 'Come cittadino, Q-cumber diventa il tuo alleato per informarti e accedere facilmente alle segnalazioni della tua zona, rendendo la tua voce protagonista nella tutela del territorio.'
            } else if (['consultant'].indexOf(el.name) > -1) {
              el['alias'] = this.gettext('Consultant')
              el['picture'] = process.env.VUE_APP_CDN_URL + '/static/img/logos/q-tool.svg'
              el['description'] = 'Sei un consulente? Se abilitato, con Q-cumber puoi gestire e presentare pratiche a livello provinciale, regionale e nazionale, semplificando il tuo lavoro e valorizzando la tua professionalità.'
            } else if (['educational-institution'].indexOf(el.name) > -1) {
              el['alias'] = this.gettext('Educational Institution')
              el['picture'] = process.env.VUE_APP_CDN_URL + '/static/img/logos/q-edu.svg'
              el['description'] = 'Q-cumber offre a Scuole ed Università una piattaforma unica per promuovere progetti di educazione e sostenibilità ambientale, coinvolgendo studenti e insegnanti nella tutela del pianeta.'
            } else if (['enterprise'].indexOf(el.name) > -1) {
              el['alias'] = this.gettext('Enterprise')
              el['picture'] = process.env.VUE_APP_CDN_URL + '/static/img/logos/q-business.svg'
              el['description'] = 'Q-cumber è il partner ideale per la tua impresa: gestisci segnalazioni e pratiche amministrative con efficienza e trasparenza, a livello locale e nazionale, per crescere in armonia con l’ambiente.'
            } else if (['institutional-assessor'].indexOf(el.name) > -1) {
              el['alias'] = this.gettext('Institutional Assessor')
              el['picture'] = process.env.VUE_APP_CDN_URL + '/static/img/logos/q-city.svg'
              el['description'] = 'Q-cumber ti aiuta, come istituzione pubblica, a gestire segnalazioni e pratiche amministrative con un approccio innovativo e sostenibile, favorendo la collaborazione con il territorio.'
            }
            return el
        })
      } else {
        return []
      }
    },

    stepActivated (step) {
      console.log('step activated', step)
      if (step === 'instructions') {
        this.clearNextSteps()
      }

      if (step === 'check_browser') {
        this.checkBrowser()
      } else if (step === 'fetch_backend_stats') {
        this.fetchBackendStatsP().then(
          response => {
            this.stepCompleted(step, response, 'check_availability')
          },
          error => {
            this.stepFailed(step, error)
          }
        )
      } else if (step === 'check_availability') {
        if (this.signupClosed) {
          // console.log('signup closed')
        } else {
          this.stepCompleted(step, null, 'select-country')
        }
      } else if (step === 'select-country') {

      } else if (step === 'choose-user-type') {
        console.log('groups', this.groupsList())
        //let selectedGroup = this.groupsList().filter((g) => {
        //  return g.name == 'citizen'
        //})[0]
        //console.log('selected group', selectedGroup)
        // inibita la selezione tipologia di utente
        // this.stepCompleted(step, selectedGroup)
      //} else if (step === 'show-user-type-info') {
      } else if (step === 'check_user_type') {
        let choosenUserType = this.getStepResult('choose-user-type')
        if (choosenUserType && ['citizen'].indexOf(choosenUserType.name) > -1 ) {
            setTimeout(() => {
              this.stepCompleted(step, true)
            }, 199)
        } else {
            window.location.href = process.env.VUE_APP_EVENTS_URL + '/request-for-credentials/?group=' + choosenUserType.name
        }
        //this.stepCompleted(step, null)
      } else if (step === 'check_email') {
        this.checkUserNotExistenceP(this.userEmail, 'email').then(
          response => {
            this.stepCompleted(step, response)
          },
          error => {
            this.stepFailed(step, error, 'insert-email')
          }
        )
      } else if (step === 'check_password') {
        // checking password length
        if (!this.userPassword || this.userPassword.length < 8) {
           let msg = this.gettext('Password must be at least 8 characters long.')
           this.stepFailed('check_password', msg, 'insert-password')
        } else {
           this.stepCompleted(step, this.userPassword)
        }
      } else if (step === 'check_confirmed_password') {
        // checking password equality
        if (!this.userPassword2 || this.userPassword2 !== this.userPassword) {
           let msg = this.gettext("Password didn't match.")
           this.stepFailed('check_confirmed_password', msg, 'insert-password')
        } else {
           this.stepCompleted(step, this.userPassword2)
        }
      } else if (step === 'run_tasks') {
        let choosenGroups = this.choosenUserType ? [this.choosenUserType] : []
        // append ISO 3166-1 alpha-2 country code to groups
        choosenGroups.push(this.countryCode)

        let obj = {
          email: this.userEmail,
          password1: this.userPassword,
          password2: this.userPassword2,
          groups: choosenGroups,
          fingerprint: this.browserFingerprint
        }

        this.performApiSignupP(obj).then(
          response => {
            this.stepCompleted(step, response)
          },
          error => {
            this.stepFailed(step, error)
          }
        )
      } else if (step === 'send_events') {
        setTimeout(() => {
            this.stepCompleted(step, null)
        }, 199)
      } else if (step === 'result') {
        this.completeOperation()
      }
    },
    slideChanged (step) {
      if (step === 'insert-email') {
        if (this.firstStepError) {
          this.$refs.userEmailInput.clear()
        } else {
          this.$refs.userEmailInput.focus()
        }
      } else if (step === 'insert-password') {
        if (this.firstStepError || this.getStepError('check_password') || this.getStepError('check_confirmed_password')) {
          this.$refs.userPasswordInput.clear()
        } else {
          this.$refs.userPasswordInput.focus()
        }
      } else if (step === 'confirm-password') {
        if (this.firstStepError || this.getStepError('check_confirmed_password')) {
          this.$refs.userPasswordInput2.clear()
        } else {
          this.$refs.userPasswordInput2.focus()
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "q-custom-elements/src/scss/accounts.theme";

.accounts-signup-operation {
  width: 100%;
  height: 100%;
  color: #fff;

  .informations {
    height: 180px;
    overflow: hidden;
    overflow-y: scroll;
    border-radius: 5px;
    background-color: #fff;
    color: #222;
    text-align: left;
    font-size: 16px;
    line-height: 22px;
    padding: 16px;
  }

  .instructions {
    text-align: left;
  }

  .check-informations {
    text-align: center;
  }

  .countrySelectorContainer {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding: 8px 12px;
    background-color: #fff;

    border-radius: 4px;
    border: 1px solid #fff;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);

    .countryCodeSelector {
      width: 100%;
      border: 1px solid #fff;
      font-family: Roboto, sans-serif;
      font-size: 16px;
      padding: 8px;
      background-color: #fff;
    }

    .countryCodeSelector:focus-visible {
      outline: 1px solid #fff;
    }
  }
}
</style>
